import { FC, useCallback, useMemo, useState } from 'react'

import { DropdownDynamic } from 'core-components/library/dropdown'
import { useStaticCrud } from 'core-components/types/helpers'
import { PartnerSearchFilterItem } from 'partner360/components/partnerSearchFilter'
import { PartnerSearchSelectProps } from 'partner360/components/partnerSearchFilter/components/partnerSearchSelect/models'
import { compareByPartnerName } from 'partner360/components/partnerSearchFilter/helpers/compareByPartnerName'
import { getUniquePartners } from 'partner360/components/partnerSearchFilter/helpers/getUniquePartners'

import { PartnerSearchRenderItem } from '../partnerSearchRenderItem/PartnerSearchRenderItem'

export const PartnerSearchSelect: FC<PartnerSearchSelectProps> = ({
  label,
  value,
  partners,
  onChange,
  placeholder = 'Partner Name, Partner ID, Location ID',
  className,
  partnerNameClassName,
}) => {
  const [searchValue, setSearchValue] = useState('')

  const uniquePartners = useMemo(
    () => getUniquePartners(partners).sort(compareByPartnerName),
    [partners]
  )

  const partnersSource = useStaticCrud<PartnerSearchFilterItem>({
    data: uniquePartners,
    keyField: 'PartnerId',
    displayField: 'PartnerName',
  })

  // const ObservableInput = useMemo(() => {
  //   const Component = forwardRef<HTMLInputElement, IInputProps>(
  //     ({ onChange: onInputChange, ...props }, ref) => {
  //       const handleChangeInput = (nextValue: string) => {
  //         setSearchValue(nextValue)
  //         onInputChange?.(nextValue)
  //       }
  //
  //       return <Input {...props} ref={ref} placeholder={placeholder} onChange={handleChangeInput} />
  //     }
  //   )
  //
  //   Component.displayName = 'PartnerSearchSelectInput'
  //
  //   return Component
  // }, [placeholder])

  const itemRenderer = useCallback(
    (partner: PartnerSearchFilterItem) => {
      return (
        <PartnerSearchRenderItem
          partner={partner}
          searchValue={searchValue}
          partnerNameClassName={partnerNameClassName}
        />
      )
    },
    [partnerNameClassName, searchValue]
  )

  return (
    <DropdownDynamic
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      source={partnersSource}
      caption="PartnerName"
      value={value}
      label={label as any}
      fieldsToSearch={['GeoMarket', 'Country', 'PartnerName', 'PartnerId', 'LocationId']}
      renderFunction={itemRenderer}
      onChange={onChange}
      // InputComponent={ObservableInput}
    />
  )
}
